import { PageHeader, Row, Col, Tag, Tooltip, message, Popconfirm } from "antd";
import { FileZipOutlined, ShopOutlined, DownloadOutlined, DeleteOutlined, ImportOutlined } from "@ant-design/icons";
import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import moment from "moment";
import {
    Form,
    FormItem,
    ButtonItem,
    ErrorItem,
    RangePickerItem,
    TableItemDinamico,
} from "../../../Components/Items";
import SelectEmpresasBiwoItem from "../../../Components/SelectEmpresasBiwoItem";

class DescargasSat extends Component {
    formRef = React.createRef();
    tableRef = null;
    state = {
        empresaId: null,
        loading: false,
        todasSolicitudes: [],
        totalRecords: 0,
    };

    onFinishFailed(e) {
        ErrorItem(e);
    }

    onChangeEmpresa(empresaId) {
        this.setState({ empresaId }, () => {
            if (this.tableRef) this.tableRef.updateExternalFilters({ empresaId });
        });
    }

    consultarSolicitudes(params) {
        this.setState({ loading: true });
        axios
            .post(
                "descargasSatBiwo/selectSolicitudes",
                { empresaId: this.state.empresaId, ...params },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    this.setState({
                        todasSolicitudes: res.data.data,
                        totalRecords: res.data.totalRecords || 0,
                    });
                } else {
                    this.setState({ todasSolicitudes: [], totalRecords: 0 });
                }
            });
    }

    refrescarTabla() {
        if (this.tableRef) {
            this.tableRef.updateExternalFilters({ empresaId: this.state.empresaId });
        }
    }

    crearConsultaZip(emision = false) {
        const values = this.formRef.current?.getFieldsValue();
        if (!values?.empresaId || !values?.fechas) {
            message.error("Selecciona una empresa y un rango de fechas");
            return;
        }
        this.setState({ loading: true });
        axios
            .post(
                "descargasSatBiwo/crearConsultaZip",
                {
                    empresaId: values.empresaId,
                    startDate: values.fechas[0],
                    endDate: values.fechas[1],
                    emision,
                },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se creó la consulta, el ZIP estará disponible en unos minutos");
                    this.refrescarTabla();
                } else {
                    message.error(res.data.message || "No se pudo crear la consulta");
                }
            });
    }

    crearConsultaEmpresa() {
        const values = this.formRef.current?.getFieldsValue();
        if (!values?.empresaId || !values?.fechas) {
            message.error("Selecciona una empresa y un rango de fechas");
            return;
        }
        this.setState({ loading: true });
        axios
            .post(
                "descargasSatBiwo/crearConsultaEmpresa",
                {
                    empresaId: values.empresaId,
                    startDate: values.fechas[0],
                    endDate: values.fechas[1],
                },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se creó la consulta para la empresa");
                    this.refrescarTabla();
                } else {
                    message.error(res.data.message || "No se pudo crear la consulta");
                }
            });
    }

    async descargarZip(solicitudId, index) {
        try {
            const res = await axios.post(
                "descargasSatBiwo/descargarZip",
                { solicitudId, index },
                { headers: this.props.headersToken, responseType: "arraybuffer" }
            );
            const blob = new Blob([res.data], { type: "application/zip" });
            const url = window.URL.createObjectURL(blob);
            const pom = document.createElement("a");
            pom.href = url;
            pom.download = `descarga_${solicitudId}_${index}.zip`;
            pom.click();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            message.error("Hubo un error y no se pudo descargar el zip");
        }
    }

    borrarZip(solicitudId) {
        this.setState({ loading: true });
        axios
            .post(
                "descargasSatBiwo/borrarZip",
                { solicitudId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se borró el zip guardado");
                    this.refrescarTabla();
                } else {
                    message.error(res.data.message || "No se pudo borrar el zip");
                }
            });
    }

    render() {
        const columns = [
            {
                title: "Empresa",
                dataIndex: "empresaNombre",
                key: "empresaNombre",
                render: (value, record) => (
                    <div>
                        <div>{value}</div>
                        <div style={{ fontSize: 12, color: "#888" }}>{record.empresaRfc}</div>
                    </div>
                ),
            },
            {
                title: "Rango de fechas",
                dataIndex: "startDate",
                key: "startDate",
                render: (value, record) =>
                    `${moment(record.startDate).format("DD/MM/YYYY")} - ${moment(record.endDate).format("DD/MM/YYYY")}`,
            },
            {
                title: "Tipo",
                dataIndex: "tipoCronSat",
                key: "tipoCronSat",
                render: (value, record) =>
                    value === "manual_zip" ? (
                        <>
                            <Tag color="purple">Zip interno (Biwo)</Tag>
                            <Tag color={record.emision ? "gold" : "cyan"}>
                                {record.emision ? "Emisión" : "Recepción"}
                            </Tag>
                        </>
                    ) : (
                        <Tag color="blue">Empresa</Tag>
                    ),
            },
            {
                title: "Estado",
                dataIndex: "terminada",
                key: "terminada",
                render: (value, record) => {
                    if (record.error) return <Tag color="red">Error{record.errorDescription ? `: ${record.errorDescription}` : ""}</Tag>;
                    if (value) return <Tag color="green">Terminada</Tag>;
                    return <Tag color="orange">Pendiente</Tag>;
                },
            },
            {
                title: "Archivos",
                dataIndex: "archivosDescargados",
                key: "archivosDescargados",
                render: (value, record) =>
                    record.tipoCronSat === "manual_zip"
                        ? `${record.zipsGuardados?.length || 0} zip(s)`
                        : `${value || 0} xml(s)`,
            },
            {
                title: "Acción",
                dataIndex: "accion",
                key: "accion",
                render: (value, record) => {
                    const esZip = record.tipoCronSat === "manual_zip";
                    const puedeDescargar = esZip && record.terminada && !record.zipBorrado && (record.zipsGuardados?.length || 0) > 0;

                    if (!esZip) return null;

                    if (!puedeDescargar) {
                        return record.zipBorrado ? <Tag>Zip borrado</Tag> : null;
                    }

                    return (
                        <div style={{ display: "flex", gap: 4 }}>
                            {record.zipsGuardados.map((_, index) => (
                                <Tooltip title={`Descargar zip ${index + 1}`} key={index}>
                                    <ButtonItem
                                        size="small"
                                        olivo
                                        icon={<DownloadOutlined />}
                                        onClick={() => this.descargarZip(record._id, index)}
                                    />
                                </Tooltip>
                            ))}
                            <Popconfirm
                                title="¿Borrar el/los zip guardados?"
                                onConfirm={() => this.borrarZip(record._id)}
                                okText="Si"
                                cancelText="No"
                            >
                                <Tooltip title="Borrar">
                                    <ButtonItem size="small" rojo icon={<DeleteOutlined />} />
                                </Tooltip>
                            </Popconfirm>
                        </div>
                    );
                },
            },
        ];

        return (
            <>
                <PageHeader
                    title="Descargas SAT"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                />
                <div style={{ backgroundColor: "white", padding: 20, paddingTop: 5, marginBottom: 10 }}>
                    <Form ref={this.formRef} name="descargasSat" layout onFinishFailed={this.onFinishFailed.bind(this)}>
                        <Row style={{ marginTop: 20 }}>
                            <Col span={24} xs={24} sm={24} md={12} lg={10}>
                                <FormItem name="empresaId" label="Empresa" required>
                                    <SelectEmpresasBiwoItem
                                        placeholder="Seleccionar empresa"
                                        onChange={this.onChangeEmpresa.bind(this)}
                                    />
                                </FormItem>
                            </Col>
                            <Col span={24} xs={24} sm={24} md={12} lg={8}>
                                <FormItem name="fechas" label="Rango de fechas" required>
                                    <RangePickerItem style={{ width: "100%" }} />
                                </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24} style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                                <Popconfirm
                                    title={
                                        <div style={{ maxWidth: 320 }}>
                                            <p style={{ marginBottom: 8, fontWeight: 600 }}>
                                                ¿Generar consulta ZIP interna de Biwo?
                                            </p>
                                            <p style={{ marginBottom: 0 }}>
                                                Descarga el ZIP tal cual del SAT sin extraer los XML. Se guarda en el servidor y podrás descargarlo o borrarlo después.
                                            </p>
                                        </div>
                                    }
                                    onConfirm={() => this.crearConsultaZip()}
                                    okText="Si"
                                    cancelText="No"
                                >
                                    <ButtonItem icon={<FileZipOutlined />} disabled={this.state.loading}>
                                        Generar consulta ZIP (interna)
                                    </ButtonItem>
                                </Popconfirm>
                                <Popconfirm
                                    title={
                                        <div style={{ maxWidth: 320 }}>
                                            <p style={{ marginBottom: 8, fontWeight: 600 }}>
                                                ¿Generar ZIP de emisión (interna de Biwo)?
                                            </p>
                                            <p style={{ marginBottom: 0 }}>
                                                Descarga el ZIP tal cual del SAT con los CFDI que la empresa emitió (no los que recibió), sin extraer los XML. Se guarda en el servidor y podrás descargarlo o borrarlo después.
                                            </p>
                                        </div>
                                    }
                                    onConfirm={() => this.crearConsultaZip(true)}
                                    okText="Si"
                                    cancelText="No"
                                >
                                    <ButtonItem icon={<FileZipOutlined />} disabled={this.state.loading}>
                                        Generar ZIP de emisión
                                    </ButtonItem>
                                </Popconfirm>
                                <Popconfirm
                                    title={
                                        <div style={{ maxWidth: 320 }}>
                                            <p style={{ marginBottom: 8, fontWeight: 600 }}>
                                                ¿Generar consulta para la empresa?
                                            </p>
                                            <p style={{ marginBottom: 0 }}>
                                                Se comporta como cualquier otra consulta: procesa los XML y los deja disponibles dentro de Archivos XML de la empresa.
                                            </p>
                                        </div>
                                    }
                                    onConfirm={() => this.crearConsultaEmpresa()}
                                    okText="Si"
                                    cancelText="No"
                                >
                                    <ButtonItem icon={<ShopOutlined />} disabled={this.state.loading}>
                                        Generar consulta para empresa
                                    </ButtonItem>
                                </Popconfirm>
                                <ButtonItem
                                    icon={<ImportOutlined />}
                                    onClick={() => {
                                        const base = this.props.match.url.substring(0, this.props.match.url.lastIndexOf("/"));
                                        this.props.history.push(base + "/importarSatEntidades");
                                    }}
                                >
                                    Importar clientes/proveedores e insumos desde XML
                                </ButtonItem>
                            </Col>
                        </Row>
                    </Form>
                </div>
                <TableItemDinamico
                    ref={(ref) => (this.tableRef = ref)}
                    onRef={(ref) => (this.tableRef = ref)}
                    totalRecords={this.state.totalRecords}
                    onFetchData={this.consultarSolicitudes.bind(this)}
                    loading={this.state.loading}
                    size="small"
                    dataSource={this.state.todasSolicitudes}
                    columns={columns}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
    };
};

export default connect(mapStateToProps)(DescargasSat);
